import { FormV3 } from '@bepatient/common';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyFormActions, MyFormActionTypes } from './my-form-store.actions';

interface MyFormState {
  form: FormV3;
  url: string;
  selectedActivityUuid: string;
  isPageUpdated: boolean;
}

export const myFormInitialState: MyFormState = {
  form: undefined,
  url: undefined,
  selectedActivityUuid: undefined,
  isPageUpdated: false
};

export function myFormReducer(
  state = myFormInitialState,
  action: MyFormActions
): MyFormState {
  switch (action.type) {
    case MyFormActionTypes.LOAD_FORM_SUCCESS:
      return { ...state, form: action.payload };

    case MyFormActionTypes.SET_NEW_INPUT_ADDED:
      return { ...state, isPageUpdated: action.payload };

    case MyFormActionTypes.PREV_PAGE:
      return {
        ...state,
        form: {
          ...state.form,
          currentPage: state.form.currentPage - 1,
          prevPage: state.form.currentPage,
          invalidFields: []
        }
      };

    case MyFormActionTypes.NEXT_PAGE:
    case MyFormActionTypes.SAVE_CURRENT_PAGE_SUCCESS:
      return {
        ...state,
        form: {
          ...state.form,
          currentPage: state.form.currentPage + 1,
          prevPage: state.form.currentPage,
          invalidFields: []
        }
      };

    case MyFormActionTypes.LOAD_FORM:
    case MyFormActionTypes.RESET_FORM:
      return {
        form: undefined,
        url: undefined,
        selectedActivityUuid: undefined,
        isPageUpdated: false
      };

    case MyFormActionTypes.SET_FORM_UUID:
      return {
        ...state,
        url: action.payload.formUuid,
        selectedActivityUuid: action.payload.selectedActivity
      };

    case MyFormActionTypes.SET_FORM_INVALID_FIELDS:
      return {
        ...state,
        form: { ...state.form, invalidFields: action.payload }
      };

    case MyFormActionTypes.SET_FORM_SKIP_PAGE:
      return {
        ...state,
        form: { ...state.form, skip: action.payload }
      };

    default:
      return state;
  }
}

const myFormState = createFeatureSelector<MyFormState>('myForm');

export const selectorMyFormUrl = createSelector(
  myFormState,
  state => state.url
);

export const selectorMyFormIsPageUpdated = createSelector(
  myFormState,
  state => state.isPageUpdated
);

export const selectorMyFormSelectedActivityUuid = createSelector(
  myFormState,
  state => state.selectedActivityUuid
);

export const selectorMyFormForm = createSelector(
  myFormState,
  state => state.form
);

export const selectorMyFormInvalidFieldsId = createSelector(
  myFormState,
  state => (state.form && state.form.invalidFields) || []
);
